import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// import { environment } from "src/environments/environment";
import { environment } from "../../environments/environment";

@Injectable()
export class TransporterService {
  constructor(private httpClient: HttpClient) {}
}
